import { render, staticRenderFns } from "./tableTopBottom.vue?vue&type=template&id=7f3225bc&scoped=true&"
import script from "./tableTopBottom.vue?vue&type=script&lang=js&"
export * from "./tableTopBottom.vue?vue&type=script&lang=js&"
import style0 from "./tableTopBottom.vue?vue&type=style&index=0&id=7f3225bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3225bc",
  null
  
)

export default component.exports